import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR } = theme.mixins;
  return {
    pagesLinkSection: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        flexWrap: 'wrap',
      },
    },
    subTitle: {
      '& h2': {
        marginTop: pxToRem(48),
        marginBottom: pxToRem(40),
        [theme.breakpoints.down('md')]: {
          marginTop: pxToRem(28),
          marginBottom: pxToRem(28),
        }
      }
    },
    pageLinks: {
      color: theme.mixins.AbuDhabiOrange(),
      marginBottom: pxToRem(12),
      flexBasis: '100%',
      [theme.breakpoints.up('lg')]: {
        flexBasis: '50%',
        '&:hover': {
          color: theme.mixins.AbuDhabiOrange(500),
          '& .MuiAvatar-root': {
            backgroundColor: theme.mixins.AbuDhabiOrange(),
            '& .animateIcon': {
              animationName: '$arrowMove',
              animationDuration: '.5s',
              animationIterationCount: '1',
            },
          },
          '& .MuiSvgIcon-root': {
            color: theme.mixins.White(),
          },
        },
      },
      '& .MuiAvatar-root': {
        width: pxToRem(32),
        height: pxToRem(32),
        ...marginLR(0, pxToRem(8)),
      },
      '& .MuiSvgIcon-root': {
        color: theme.mixins.AbuDhabiOrange(),
        marginTop: 2,
        width: pxToRem(20),
        height: pxToRem(20),
      },
    },
    '@keyframes arrowMove': {
      '0%': { transform: 'translateX(0)' },
      '50%': { transform: `translateX(${theme.mixins.translateX(130)}%)` },
      '51%': { transform: `translateX(${theme.mixins.translateX(-130)}%)` },
      '100%': { transform: 'translateX(0)' },
    },
  };
});

export default useStyles;
